import companyToken from "Utils/companyToken";
import fetchWithCSRFToken from "Utils/fetchWithCSRFToken";

import type { ConciergeStep, ReplyResponse, TranscriptResponse } from "./conciergeChat.types";

// `active` is the well-known alias for this company_profile's current chat; the
// company_profile is resolved server-side from the token/session on the request.
const BASE = "/api/v2/concierge_chats/active";

// Adds the company token (when present) and the domain that selects the backend chat.
function buildUrl(path: string, domain: string): string {
  const params = new URLSearchParams();
  const token = companyToken();
  if (token) params.set("company_id_token", token);
  params.set("domain", domain);
  return `${path}?${params.toString()}`;
}

// GET the persisted transcript for rehydration on mount; empty when there's no
// active chat yet.
export async function loadTranscript(domain: string): Promise<ConciergeStep[]> {
  const res = await fetchWithCSRFToken(buildUrl(BASE, domain), { method: "GET" });
  if (!res.ok) throw new Error(`concierge transcript failed: ${res.status}`);
  const data: TranscriptResponse = await res.json();
  return data.messages;
}

// POST a message; returns the agent's reply step.
export async function sendMessage(message: string, domain: string): Promise<ConciergeStep> {
  const res = await fetchWithCSRFToken(buildUrl(`${BASE}/messages`, domain), {
    method: "POST",
    body: JSON.stringify({ message }),
  });
  if (!res.ok) throw new Error(`concierge send failed: ${res.status}`);
  const data: ReplyResponse = await res.json();
  return data.reply;
}
